{
  "title": "Ajouter le client à un ménage",
  "relationship": "Relation",
  "relationshipTo": "Relation avec le membre principal {{whom}}",
  "alreadyMemberOf": "Le client est déjà membre de",
  "thisHousehold": "ce ménage",
  "anotherHousehold": "un autre ménage",
  "memberSummary": "Résumé concernant le membre du ménage",
  "pleaseReview": "Veuillez passer en revue vos renseignements afin de vérifier leur exactitude.",
  "name": "Nom du client",
  "householdName": "Nom du ménage",
  "addToHousehold": "Ajouter au ménage",
  "added": "{{memberName}} a été ajouté au ménage {{householdName}}",
  "failed": "Échec de l'ajout d'un nouveau membre.",
  "done": "Terminé",
  "save": "Enregistrer",
  "continue": "Continuer",
  "accessType": "Autorisations",
  "householdUpdated": "Le ménage a été mis à jour pour le client",
  "clientAddedToHousehold": "Le client a été ajouté au ménage",
  "alreadyMemberOfHousehold": "Le client est déjà membre de {{householdName}}",
  "back": "Retour"
}
